/**
 * Fixed-width mask for stored credentials (PR 3 review finding 6).
 *
 * The width is deliberately constant: masking with `'*'.repeat(value.length)`
 * published the stored credential's exact length to anyone reading the page or
 * its HTML, which is free reconnaissance for no display benefit.
 */
const MASK = '••••••••';

/** Mask an API key — fixed-width dots, then the last 4 characters. */
export const maskKey = (key: string): string => {
  if (!key) return key;
  // Under 5 characters there is no suffix worth revealing: the "last 4" would
  // be all but the whole key, so the mask stands alone.
  return key.length < 5 ? MASK : MASK + key.slice(-4);
};

/** Mask a secret — fixed-width dots, no suffix revealed. */
export const convertToPasswordFormat = (secret: string): string => (secret ? MASK : '');
